import { Layout } from "@Components/Layout";
import dynamic from "next/dynamic";
const ReturnAndRefunds = dynamic(() =>
  import("@Components/Pages/Pre-Footer/Return-And-Refunds")
);
const ReturnAndRefundsPage = () => {
  return (
    <Layout>
      <ReturnAndRefunds />
    </Layout>
  );
};
export default ReturnAndRefundsPage;
